import { defineComponent as _defineComponent } from 'vue'
import { LazyAppDialogModal } from '#components'

const defaultOkText = 'Ok'
const defaultCancelText = 'Cancel'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDialog',
  setup(__props) {

const overlay = useOverlay()

function openDialog(props: {
  message: string
  okText: string
  cancelText: string
  isError: boolean
}) {
  const modal = overlay.create(LazyAppDialogModal, { destroyOnClose: true })
  return modal.open(props)
}

useDialogMount({
  alert(message, options) {
    return openDialog({
      message,
      okText: options?.okText ?? defaultOkText,
      cancelText: '',
      isError: false,
    })
  },
  confirm(message, options) {
    return openDialog({
      message,
      okText: options?.okText ?? defaultOkText,
      cancelText: options?.cancelText ?? defaultCancelText,
      isError: false,
    })
  },
  error(message, options) {
    return openDialog({
      message,
      okText: options?.okText ?? defaultOkText,
      cancelText: '',
      isError: true,
    })
  },
})

return () => {}
}

})